import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "filterable-list__list-wrapper" };
const _hoisted_2 = { class: "filterable-list__list" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_NewsListTitle = _resolveComponent("NewsListTitle");
    const _component_NewsListItem = _resolveComponent("NewsListItem");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_NewsListTitle),
        _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
                return (_openBlock(), _createBlock(_component_NewsListItem, {
                    key: item.id,
                    item: item
                }, null, 8 /* PROPS */, ["item"]));
            }), 128 /* KEYED_FRAGMENT */))
        ])
    ]));
}
